<template>
  <SectionListIcon015
    v-if="contextData"
    :title="contextData.title"
    :description="contextData.description"
    :items="contextItems"
    :theme="theme"
  />
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IItem {
    name: string;
    description?: string;
    thumbnail: string;
  }

  interface IListFeaturesSplitData {
    title: string;
    description?: string;
    items: IItem[];
  }

  interface IListFeaturesSplit {
    component: 'list-features-split';
    meta: {
      navigable?: string;
    };
    data: IListFeaturesSplitData;
  }

  type IProps = ISuiteProps<IListFeaturesSplit>;

  const props = defineProps<IProps>();

  const solutionsStore = useSolutionsStore();
  const { themeStyle } = storeToRefs(solutionsStore);

  const { provideSuiteThumbnailUrl } = useImagePath(props.urlConnector);

  const contextData = computed(
    (): IListFeaturesSplitData => props.suiteData.data
  );

  const contextItems = computed((): IItem[] =>
    contextData.value.items.map((item) => ({
      ...item,
      thumbnail: provideSuiteThumbnailUrl(item.thumbnail),
      description: undefined,
      descriptionHtml: item.description,
    }))
  );

  const theme = computed((): TTheme => {
    switch (themeStyle.value) {
      case 'sustainable':
        return 'green';
      case 'connected':
        return 'cyan';
      case 'ai':
        return 'purple';
      case 'operations':
        return 'yellow';
      default:
        return 'blue';
    }
  });

  export type { IItem, IListFeaturesSplit, IListFeaturesSplitData };
</script>
